import axios from "axios";
import baseUrl from "../Api";
import { toast } from "react-toastify";

const authHeader = () => ({
  Authorization: "Bearer " + localStorage.getItem("token"),
  "Content-Type": "application/json",
});

function catcherror(error) {
  if (error?.response?.status === 401) {
    localStorage.clear();
    window.location.href = "/";
  } else {
    // 422 verification failures carry a useful message; surface it
    toast.error(
      error?.response?.data?.message || error?.message || "Something went wrong"
    );
  }
  return error?.response?.data;
}

export async function kycStatus(memberId) {
  try {
    return await axios
      .get(`${baseUrl}/kyc/status/${memberId}`, { headers: authHeader() })
      .then((res) => res.data)
      .catch(catcherror);
  } catch (e) {
    return catcherror(e);
  }
}

export async function verifyPan(data) {
  try {
    return await axios
      .post(`${baseUrl}/kyc/pan`, data, { headers: authHeader() })
      .then((res) => res.data)
      .catch(catcherror);
  } catch (e) {
    return catcherror(e);
  }
}

export async function aadhaarSendOtp(data) {
  try {
    return await axios
      .post(`${baseUrl}/kyc/aadhaar/send-otp`, data, { headers: authHeader() })
      .then((res) => res.data)
      .catch(catcherror);
  } catch (e) {
    return catcherror(e);
  }
}

export async function aadhaarVerifyOtp(data) {
  try {
    return await axios
      .post(`${baseUrl}/kyc/aadhaar/verify-otp`, data, { headers: authHeader() })
      .then((res) => res.data)
      .catch(catcherror);
  } catch (e) {
    return catcherror(e);
  }
}

export async function verifyBank(data) {
  try {
    return await axios
      .post(`${baseUrl}/kyc/bank`, data, { headers: authHeader() })
      .then((res) => res.data)
      .catch(catcherror);
  } catch (e) {
    return catcherror(e);
  }
}
